export default {
  OPENP_VISA: 'visa',
  OPENP_AMEX: 'amex',
  OPENP_MAST: 'master',
  OPENP_INTR: 'interac',
  presto: 'presto',
  anonymous: 'anonymous',
};
